export default __webpack_public_path__ + "static/media/ProfilePicture.97f2781a.jpg";